import { React, useState, Fragment, useEffect } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Container, Grid, IconButton, List, ListItem, ListItemText, Tooltip } from "@mui/material";

import { stylesSx } from "./styles";
import GenericDialog from "common/components/GenericDialog/GenericDialog";
import DialogUserEstablishmentContent from "modules/authentication/pages/SuperAdmin/components/DialogUserEstablishmentContent";
import { useAuth } from "context/AuthContext";
import { ApiService } from "common/services/ApiService";
import { ROLE_MAP } from "utils/constants";
import GenericAlert from "common/components/GenericAlert/GenericAlert";
import { DialogUpdatePasswordContent } from "modules/authentication/pages/SuperAdmin/components/DialogUpdatePasswordContent";
import HelpIcon from "@mui/icons-material/Help";

const Profile = () => {
    const { containerStyle, cardStyle } = stylesSx;
    const { auth } = useAuth();

    const [user, setUser] = useState({});
    const [dataSubmit, setDataSubmit] = useState({});
    const [openDialog, setOpenDialog] = useState(false);
    const [openPasswordDialog, setOpenPasswordDialog] = useState(false);
    const [pendingUserRoleEstablishment, setPendingUserRoleEstablishment] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [severity, setSeverity] = useState("");
    const [alertText, setAlertText] = useState("");

    const [originalPassword, setOriginalPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [userEstablishmentSuccess, setUserEstablishmentSuccess] = useState(false);

    const [updatePasswordSuccess, setUpdatePasswordSuccess] = useState(false);

    const handleSave = async () => {
        if (!dataSubmit.roles || dataSubmit.roles.length === 0) {
            setAlertText("Debe seleccionar al menos un rol");
            setSeverity("error");
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                setAlertText("");
                setSeverity("");
            }, 2500);
            return;
        }
        const data = {
            ...dataSubmit,
            roles: dataSubmit.roles.map((r) => r.value),
            user: user.id,
        };

        const res = await ApiService.requestUserRoleEstablishment(data);
        if (res.status === 200) {
            setAlertText("La solicitud se creó con éxito!");
            setSeverity("success");
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                setAlertText("");
                setSeverity("");
            }, 3000);
            getDataUser();
            setUserEstablishmentSuccess(true);
        } else {
            setAlertText("Ocurrió un error, intente nuevamente!");
            setSeverity("error");
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                setAlertText("");
                setSeverity("");
            }, 3000);
        }
    };
    async function handleSavePassword() {
        if (!originalPassword.password || !newPassword.password || !confirmPassword.password) {
            setAlertText("Debe completar todos los campos");
            setSeverity("error");
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                setAlertText("");
                setSeverity("");
            }, 2500);
            return;
        }

        if (newPassword.password !== confirmPassword.password) {
            setAlertText("Las contraseñas no coinciden");
            setSeverity("error");
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                setAlertText("");
                setSeverity("");
            }, 2500);
            return;
        }

        if (
            newPassword.password.length < 8 ||
            confirmPassword.password.length < 8 ||
            newPassword.password.length > 16 ||
            confirmPassword.password.length > 16
        ) {
            setAlertText("La contraseña debe entre 8 y 16 caracteres");
            setSeverity("error");
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                setAlertText("");
                setSeverity("");
            }, 2500);
            return;
        }

        try {
            const res = await ApiService.resetPassword({
                old_password: originalPassword.password,
                new_password: newPassword.password,
                confirm_password: confirmPassword.password,
            });

            if (res.status === 200) {
                setAlertText("Contraseña actualizada con éxito");
                setSeverity("success");
                setShowAlert(true);
                setTimeout(() => {
                    setShowAlert(false);
                    setAlertText("");
                    setSeverity("");
                }, 2500);
                setUpdatePasswordSuccess(true);
            }
        } catch (error) {
            setAlertText("Error al actualizar la contraseña");
            setSeverity("error");
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                setAlertText("");
                setSeverity("");
            }, 2500);
        }
    }

    const getDataUser = async () => {
        const result = await ApiService.me(auth?.access);
        const dataUser = result.data;
        setPendingUserRoleEstablishment(
            dataUser && dataUser.role_establishment_pending_list.length > 0
        );
        setUser(dataUser);
    };

    useEffect(() => {
        getDataUser();
    }, []);

    return (
        <Container sx={containerStyle}>
            <Card sx={cardStyle}>
                <CardContent sx={{ textAlign: "center" }}>
                    <Typography gutterBottom variant="p">
                        <strong>Nombre y apellido</strong>
                    </Typography>
                    <br />
                    <Typography gutterBottom variant="p">
                        {`${user.first_name} ${(user.last_name || "").toUpperCase()}`}
                    </Typography>
                    <br />
                    <Typography gutterBottom variant="p">
                        <strong>Email</strong>
                    </Typography>
                    <br />
                    <Typography gutterBottom variant="p">
                        {user.email}
                    </Typography>
                    <br />
                    <br />
                    <Typography gutterBottom variant="p">
                        <strong>Establecimientos Relacionados</strong>
                        <ul style={{ marginTop: 0 }}>
                            {user.role_establishment_list?.map((ure, idx) => (
                                <li
                                    key={ure.establishment.id}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    - {ure.establishment.name}
                                    <Tooltip
                                        enterTouchDelay={0}
                                        leaveTouchDelay={15000}
                                        disableTouchListener={false}
                                        title={
                                            <ul
                                                style={{
                                                    listStyleType: "none",
                                                    margin: 0,
                                                    paddingLeft: 0,
                                                    fontSize: 12,
                                                    wordWrap: "break-word",
                                                }}
                                            >
                                                <li key={`prov-${ure.establishment.province}`}>
                                                    - Provincia: {ure?.establishment?.province}
                                                </li>
                                                <li key={`loc-${ure.establishment.province}`}>
                                                    - Localidad: {ure?.establishment?.location}
                                                </li>
                                                <li
                                                    key={`role-${idx}`}
                                                    style={{ whiteSpace: "normal" }}
                                                >
                                                    - Roles:{" "}
                                                    <span style={{ display: "inline" }}>
                                                        {ure?.roles
                                                            .map((r) => ROLE_MAP[r])
                                                            .join(", ")}
                                                    </span>
                                                </li>
                                            </ul>
                                        }
                                    >
                                        <IconButton size="small">
                                            <HelpIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </li>
                            ))}
                        </ul>
                    </Typography>
                </CardContent>
                <CardActions sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    {pendingUserRoleEstablishment && (
                        <div>
                            <Typography variant="body2" color="text.secondary" align="center">
                                Usted tiene pendiente de aprobación los siguientes roles
                            </Typography>
                            <Typography variant="body2" color="text.secondary" align="center">
                                <i>
                                    Debe esperar a que se acepten sus solicitudes pendientes para
                                    solicitar un nuevo rol
                                </i>
                            </Typography>
                            <List>
                                {user?.role_establishment_pending_list.map((re, idx) => (
                                    <Fragment key={idx}>
                                        <ListItem disablePadding>
                                            <ListItemText primary={`- ${re.establishment.name}`} />
                                        </ListItem>
                                        <ListItem disablePadding sx={{ pl: 5 }}>
                                            <ListItemText
                                                primary={`Roles: ${re.roles
                                                    .map((role) => ROLE_MAP[role])
                                                    .join(", ")}`}
                                            />
                                        </ListItem>
                                    </Fragment>
                                ))}
                            </List>
                        </div>
                    )}
                    <Button
                        variant="contained"
                        disabled={pendingUserRoleEstablishment}
                        size="small"
                        onClick={() => {
                            setOpenDialog(true);
                        }}
                    >
                        Añadir establecimiento
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => {
                            setOpenPasswordDialog(true);
                        }}
                    >
                        Cambiar contraseña
                    </Button>
                </CardActions>
                {openDialog && (
                    <GenericDialog
                        handleSave={handleSave}
                        open={openDialog}
                        closeOnSave={userEstablishmentSuccess}
                        setOpen={setOpenDialog}
                        title={"Solicitud nuevo establecimiento"}
                        onClose={() => {}}
                    >
                        <DialogUserEstablishmentContent
                            isSuperAdmin={auth?.selectedRole?.name === "superadmin"}
                            showPreviousRoleList={false}
                            selectedUser={user}
                            handleChangeExternalData={(data) => {
                                setDataSubmit({
                                    ...dataSubmit,
                                    ...data,
                                });
                            }}
                        ></DialogUserEstablishmentContent>
                    </GenericDialog>
                )}
                {openPasswordDialog && (
                    <GenericDialog
                        handleSave={handleSavePassword}
                        open={openPasswordDialog}
                        closeOnSave={updatePasswordSuccess}
                        setOpen={setOpenPasswordDialog}
                        title={"Cambiar contraseña"}
                        onClose={() => {}}
                    >
                        <DialogUpdatePasswordContent
                            originalPassword={originalPassword}
                            setOriginalPassword={setOriginalPassword}
                            newPassword={newPassword}
                            setNewPassword={setNewPassword}
                            confirmPassword={confirmPassword}
                            setConfirmPassword={setConfirmPassword}
                        />
                    </GenericDialog>
                )}
                <Grid
                    sx={{
                        position: "fixed",
                        bottom: "40%",
                        left: "40%",
                        zIndex: "9999",
                    }}
                >
                    {showAlert && (
                        <GenericAlert severity={severity} text={alertText} variant="filled" />
                    )}
                </Grid>
            </Card>
        </Container>
    );
};

export default Profile;
